import { Box, VStack, Text, Progress, Flex } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { useTranslation } from 'react-i18next';

/**
 * Loading Screen Component
 * 
 * Displays during initial app load with:
 * - Animated logo
 * - Progress indicator
 * - Loading tips
 */

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;



export function LoadingScreen({ progress = 0, message }: { progress?: number; message?: string }) {
    const { t } = useTranslation();

    return (
        <Flex
            h="100vh"
            w="full"
            bg="surface.500"
            align="center"
            justify="center"
            direction="column"
        >
            {/* Logo */}
            <Box
                mb={8}
                p={6}
                borderRadius="2xl"
                bgGradient="linear(to-br, brand.500, brand.600)"
                boxShadow="0 0 60px rgba(33, 150, 243, 0.3)"
                animation={`${pulse} 2s ease -in -out infinite`}
            >
                <VStack spacing={0}>
                    <Text
                        fontSize="4xl"
                        fontWeight="black"
                        color="white"
                        letterSpacing="tight"
                    >
                        Yap
                    </Text>
                    <Text
                        fontSize="lg"
                        fontWeight="medium"
                        color="whiteAlpha.800"
                        letterSpacing="widest"
                    >
                        PRO
                    </Text>
                </VStack>
            </Box>

            {/* Progress */}
            <VStack spacing={4} w="300px">
                <Progress
                    value={progress}
                    w="100%"
                    size="sm"
                    colorScheme="blue"
                    borderRadius="full"
                    bg="surface.400"
                    hasStripe
                    isAnimated
                />

                <Text fontSize="sm" color="gray.400" animation={`${pulse} 1.5s ease -in -out infinite`}>
                    {message ?? t('common.loading')}
                </Text>
            </VStack>

            {/* Version */}
            <Text
                position="absolute"
                bottom={4}
                fontSize="xs"
                color="gray.600"
            >
                v1.0.0 MVP
            </Text>
        </Flex>
    );
}
